import { Box, IconButton, IconButtonProps, useColorModeValue } from '@chakra-ui/react';
import { HabityTooltip } from '~/components/ui/tooltips';

interface OverlayButtonProps {
  tooltip?: TODO;
  label: string;
  onClick: IconButtonProps["onClick"];
  icon: IconButtonProps["icon"];
  buttonProps?: IconButtonProps;
  showAlways?: boolean;
}

export const OverlayButton = ({
  tooltip,
  label,
  onClick,
  icon,
  buttonProps,
  showAlways = false,
}: OverlayButtonProps) => {
  return (
    <HabityTooltip label={tooltip}>
      <Box
        position="relative"
        className="container"
        zIndex="2"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <IconButton
          bg="white"
          variant="ghost"
          borderRadius="4"
          size="sm"
          _hover={{
            backgroundColor: "white",
          }}
          // sx={{
          //   ':not(:hover)': {
          //     color: 'blackAlpha.900'
          //   },
          // }}
          aria-label={label}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick?.(e);
          }}
          icon={icon}
          {...buttonProps}
        />
      </Box>
    </HabityTooltip>
  );
};
